
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import AvailabilityManager from './AvailabilityManager';
import BlockedDatesManager from './BlockedDatesManager';
import SessionBookingsView from './SessionBookingsView';

const AvailabilityTab = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">My Availability</h2>
      
      <Tabs defaultValue="schedule" className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="schedule">Weekly Schedule</TabsTrigger>
          <TabsTrigger value="blocked">Blocked Dates</TabsTrigger>
          <TabsTrigger value="bookings">Bookings</TabsTrigger>
        </TabsList>
        
        <TabsContent value="schedule" className="mt-6">
          <AvailabilityManager />
        </TabsContent>
        
        <TabsContent value="blocked" className="mt-6">
          <BlockedDatesManager />
        </TabsContent>
        
        <TabsContent value="bookings" className="mt-6">
          <SessionBookingsView />
        </TabsContent>
      </Tabs>

      <div className="flex justify-center pt-6 border-t">
        <Button
          variant="action"
          onClick={() => navigate('/calendar')}
          className="px-6 py-3"
        >
          <Calendar className="mr-2 h-4 w-4" />
          Go to Calendar
        </Button>
      </div>
    </div>
  );
};

export default AvailabilityTab;
